/** An icon-only control. The label is mandatory — it is the accessible name
 *  and the tooltip, so no icon is ever unexplained. */
import type { ButtonHTMLAttributes } from "react";

import { Icon, type IconName } from "@/components/Icon";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  label: string;
  size?: number;
}

export function IconButton({ icon, label, size = 20, className = "", ...rest }: Props) {
  return (
    <button
      type="button"
      className={`btn-icon ${className}`}
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon name={icon} size={size} />
    </button>
  );
}
